module.exports = "<ngx-monaco-editor [options]=\"editorOptions\" [ngModel]=\"data\" style=\"min-height: 100px;\"></ngx-monaco-editor>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/show-code/show-code.component.html
// module id = ./src/app/show-code/show-code.component.html
// module chunks = main